import { Associate, AssociateRole } from "../data/models/AssociateTypes";

export const usePrimaryContact = (associates: Associate[]) => {
  return associates.filter(
    (item) => item.roles.indexOf(AssociateRole.PRIMARY_CONTACT) > -1
  )[0];
};
